//axios api
import api from "@/lib/Api";

export const getRosterByUser = async (user_id, start, end) => {
  try {
    const queryRoute = `/roster/${user_id}`;
    const body = {
      start,
      end,
    };
    const fetchRes = api.axios.post(queryRoute, body);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const getRosterByUserIdAndDate = async (user_id, date) => {
  try {
    const queryRoute = `/roster?user_id=${user_id}&date=${date}`;

    const fetchRes = api.axios.get(queryRoute);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const isRosterExist = async (user_id, date) => {
  try {
    const queryRoute = `/roster/isRosterExist`;
    const body = {
      user_id,
      date,
    };
    const fetchRes = api.axios.post(queryRoute, body);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const getRosterByLocation = async (user_id, start, end) => {
  try {
    const queryRoute = `/roster/location/${user_id}`;
    const body = {
      start,
      end,
    };
    const fetchRes = api.axios.post(queryRoute, body);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const deleteRosterByUser = async (user_id, date) => {
  try {
    const queryRoute = `/roster/deleteRosterByUser`;
    const body = {
      user_id,
      date,
    };
    const fetchRes = api.axios.post(queryRoute, body);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
export const upsertRosterByUser = async (data, transfer = false) => {
  try {
    const queryRoute = `/roster/upsertRosterByUser`;
    const body = {
      data,
      transfer,
    };
    const fetchRes = api.axios.post(queryRoute, body);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    throw err;
  }
};
export const getRosterExist = async (year) => {
  try {
    const queryRoute = `/roster/getRosterExist/`;

    const body = {
      year,
    };
    const fetchRes = api.axios.post(queryRoute, body);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getRosterByDateRange = async (startDate, endDate) => {
  try {
    const queryRoute = `/roster/getRosterByDateRange`;
    const reqBody = {
      startDate,
      endDate,
    };

    const fetchRes = api.axios.post(queryRoute, reqBody);

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getRoster = async (yearMonth, isTemplate) => {
  try {
    const queryRoute = `/roster/getRoster`;
    const reqBody = {
      yearMonth: yearMonth,
      isTemplate: isTemplate,
    };
    const fetchRes = api.axios.post(queryRoute, reqBody, {
      responseType: "blob",
    });

    return (await fetchRes).data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const importRoster = async (data) => {
  try {
    const queryRoute = `/roster/importRoster`;
    const reqBody = { data };
    const fetchRes = api.axios.post(queryRoute, reqBody);
    return (await fetchRes).data;
  } catch (err) {
    console.error(err.message);
    throw err;
  }
};

export const getPublicHolidays = async () => {
  try {
    const queryRoute = `/roster/getPublicHolidays`;

    const result = await api.axios.post(queryRoute);

    return result.data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};

export const getAddress = async (lat, lon) => {
  try {
    const queryRoute = `https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lon}&format=json&accept-language=zh-hk`;

    const result = await api.axios.get(queryRoute);

    return result.data;
  } catch (err) {
    console.log(err.message);
    return false;
  }
};
